(() => {
  const root = document.querySelector('[data-npb]');
  if (!root) return;
  const removeMoveToTop = () => {
    document.querySelectorAll('a, button').forEach(control => {
      const text = (control.textContent || '').trim();
      const identity = [control.getAttribute('aria-label'), control.getAttribute('title'), control.id, control.className].filter(Boolean).join(' ');
      const namedTopControl = /(?:back|move|scroll|go|return)[-_ ]*to[-_ ]*top/i.test(identity);
      const fixedArrow = /^[↑⇧⬆▲]$/.test(text) && getComputedStyle(control).position === 'fixed';
      if (namedTopControl || fixedArrow) control.remove();
    });
  };
  removeMoveToTop();
  new MutationObserver(removeMoveToTop).observe(document.body, { childList: true, subtree: true });
  const showMissingImage = image => {
    if (!image.isConnected) return;
    const placeholder = document.createElement('span');
    placeholder.className = 'npb__missing-image';
    placeholder.textContent = 'Photo unavailable';
    image.replaceWith(placeholder);
  };
  root.querySelectorAll('.npb__hero-image, .npb__gallery-item img').forEach(image => {
    image.addEventListener('error', () => showMissingImage(image), { once: true });
    if (image.complete && image.naturalWidth === 0) showMissingImage(image);
  });
  const form = root.querySelector('#NpbContactForm');
  const sticky = root.querySelector('[data-sticky]');
  const cta = root.querySelector('.npb__pricing-cta');
  const submit = root.querySelector('[data-submit]');
  const area = root.querySelector('#npb-venue');
  const phone = root.querySelector('#npb-phone');
  const pendingLeadKey = 'npb-photo-booth-pending-lead';
  const sentLeadKey = 'npb-photo-booth-sent-lead';
  const acceptedEnquiry = root.querySelector('[data-npb-enquiry-accepted]');
  if (acceptedEnquiry) {
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(pendingLeadKey) || 'null'); } catch (_) { pending = null; }
    if (pending && typeof pending.id === 'string' && Date.now() - pending.at < 86400000) {
      const sendConfirmedLead = () => {
        let privacyAllowed = false;
        try { privacyAllowed = window.Shopify?.customerPrivacy?.marketingAllowed() === true; } catch (_) { return false; }
        if (!privacyAllowed) return false;
        try {
          if (sessionStorage.getItem(sentLeadKey) === pending.id) return true;
          sessionStorage.setItem(sentLeadKey, pending.id);
          // Shopify's Meta app runs in a sandbox; this sends one event to its
          // existing pixel ID without initialising another Meta pixel SDK.
          const url = new URL('https://www.facebook.com/tr');
          url.searchParams.set('id', '1009156611951359');
          url.searchParams.set('ev', 'Lead');
          url.searchParams.set('noscript', '1');
          url.searchParams.set('dl', `${location.origin}${location.pathname}`);
          const beacon = new Image(1, 1);
          window.__npbLeadBeacon = beacon;
          beacon.onload = beacon.onerror = () => {
            if (window.__npbLeadBeacon === beacon) delete window.__npbLeadBeacon;
          };
          beacon.src = url.toString();
          sessionStorage.removeItem(pendingLeadKey);
          return true;
        } catch (_) { return false; }
      };
      if (!sendConfirmedLead()) {
        const checkForPixel = window.setInterval(() => {
          if (sendConfirmedLead()) window.clearInterval(checkForPixel);
        }, 500);
        window.setTimeout(() => window.clearInterval(checkForPixel), 60000);
        document.addEventListener('visitorConsentCollected', sendConfirmedLead);
        if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], sendConfirmedLead);
        }
      }
    }
  }
  area?.addEventListener('input', () => area.setCustomValidity(''));
  phone?.addEventListener('input', () => phone.setCustomValidity(''));
  form?.addEventListener('submit', event => {
    area.setCustomValidity(area.value.trim() ? '' : 'Enter your venue or area.');
    const phoneDigits = phone.value.replace(/\D/g, '');
    phone.setCustomValidity(phoneDigits.length >= 10 && phoneDigits.length <= 15 ? '' : 'Enter a valid WhatsApp number.');
    if (!form.reportValidity()) { event.preventDefault(); return; }
    try {
      sessionStorage.setItem(pendingLeadKey, JSON.stringify({ id: `${Date.now()}-${Math.random()}`, at: Date.now() }));
    } catch (_) { /* Enquiries still submit when browser storage is unavailable. */ }
    submit.disabled = true;
    submit.textContent = 'Sending enquiry…';
  });
  const contactDialog = root.querySelector('#npb-contact-dialog');
  const contactTrigger = root.querySelector('[data-contact-open]');
  contactTrigger?.addEventListener('click', () => {
    if (contactDialog && !contactDialog.open) contactDialog.showModal();
  });
  root.querySelector('[data-contact-close]')?.addEventListener('click', () => {
    if (contactDialog?.open) contactDialog.close();
  });
  contactDialog?.addEventListener('click', event => {
    if (event.target === contactDialog) contactDialog.close();
  });
  const galleryMore = root.querySelector('[data-gallery-more]');
  const galleryExtras = [...root.querySelectorAll('[data-extra-photo]')];
  galleryMore?.addEventListener('click', () => {
    const expanding = galleryMore.getAttribute('aria-expanded') !== 'true';
    galleryExtras.forEach(photo => { photo.hidden = !expanding; });
    galleryMore.setAttribute('aria-expanded', String(expanding));
    galleryMore.querySelector('[data-more-text]').textContent = expanding ? galleryMore.dataset.lessLabel : galleryMore.dataset.moreLabel;
  });
  document.addEventListener('shopify:block:select', event => {
    const photo = event.target.closest('[data-extra-photo]');
    if (photo && root.contains(photo)) {
      galleryExtras.forEach(item => { item.hidden = false; });
      galleryMore?.setAttribute('aria-expanded', 'true');
      if (galleryMore) galleryMore.querySelector('[data-more-text]').textContent = galleryMore.dataset.lessLabel;
    }
  });
  if (sticky && cta && submit) {
    const syncSticky = () => {
      sticky.hidden = window.matchMedia('(min-width: 700px)').matches || cta.getBoundingClientRect().bottom > 0 || submit.getBoundingClientRect().top <= window.innerHeight;
      document.body.style.paddingBottom = sticky.hidden ? '' : `${sticky.offsetHeight}px`;
    };
    window.addEventListener('resize', syncSticky);
    window.addEventListener('scroll', syncSticky, { passive: true });
    syncSticky();
  }
})();